import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import AppRoute from './components/router/AppRoute';
import NewBookingPage from './pages/NewBookingPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FaqsPage from './pages/FaqsPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AmendBookingPage from './pages/AmendBookingPage';
import NotFoundPage from './pages/NotFoundPage';


const AppRouter = () => (
    <BrowserRouter>
        <Switch>
            <AppRoute exact path="/" component={NewBookingPage} />
            <AppRoute exact path="/terms-and-conditions" component={TermsAndConditionsPage} />
            <AppRoute exact path="/privacy-policy" component={PrivacyPolicyPage} />
            <AppRoute exact path="/faqs" component={FaqsPage} />
            <AppRoute exact path="/login" component={LoginPage} />
            <AppRoute exact path="/booking/:id" component={AmendBookingPage} />
            <AppRoute exact path="/dashboard" component={DashboardPage} />
            <AppRoute component={NotFoundPage} />
        </Switch>
    </BrowserRouter>
);

export default AppRouter;
